import EditPrefillMenu from "../../../CRM/EditPrefillMenu";
import { PrefillPair } from "../../../../types/GlobalInterfaces";

const disabledFields = [
  "Subitem",
  "MultiSubitem",
  "Image",
  "Audio",
  "Video",
  "SingleFile",
  "Object",
  "Calculated",
];

interface Props {
  module: any;
  setDefaultValues: (defaults: PrefillPair[]) => void;
}

export default function ImportFieldDefaults({
  module,
  setDefaultValues,
}: Props) {
  return (
    <div className="mt-3">
      <h4 className="mb-0">Import Field Defaults</h4>
      <div className="small mb-3">
        Set default values for the records that will be imported.
      </div>
      {/* @ts-ignore */}
      <EditPrefillMenu
        module={module}
        onChange={setDefaultValues}
        showVariables={false}
        editOnly={true}
        disabledFields={disabledFields}
      />
    </div>
  );
}
